import React, { useContext } from 'react'
import { GlobalSiteDataContext } from '../../context'
import {
    SEO,
    AreasHero,
    BrazilianBikini,
    LipChin,
    Legs,
    DarkerSkin,
    Men,
    ShavingWaxingCalc,
    ExclusiveDivider,
} from '../../components'
import { graphql } from 'gatsby'
// import './areas.css'

function AreasPage() {
    const siteData = useContext(GlobalSiteDataContext)
    return (
        <main id="areas-page">
            <AreasHero />
            <ExclusiveDivider />
            <ShavingWaxingCalc />
            <BrazilianBikini />
            <LipChin />
            <Legs />
            <DarkerSkin />
            <Men />
        </main>
    )
}

export const Head = ({ data, location }) => {
    const query = data.siteDataJson
    return (
        <SEO
            location={location}
            origin={query.origin}
            title={`Laser Hair Removal Areas, For Men, and Skin Tones | Milan Laser in ${query.name}, ${query.stateAbbrev}`}
            description="Ready to ditch the razor? Click here to see the most popular body areas to get laser hair removal."
        />
    )
}

export const query = graphql`
    {
        siteDataJson {
            name
            stateAbbrev
            origin
        }
    }
`

export default AreasPage
